import { FTM_2019_ARTICLES } from './ftm2019';
import { ANCESTRY_ARTICLES } from './ancestry';
import { FTM_2024_ARTICLES } from './ftm2024';

export const ARTICLE_CATEGORIES = [
  { key: 'ftm-2024', label: 'Family Tree Maker 2024', hub: '/family-tree-maker-2024', articles: FTM_2024_ARTICLES },
  { key: 'ftm-2019', label: 'Family Tree Maker 2019', hub: '/family-tree-maker-2019', articles: FTM_2019_ARTICLES },
  { key: 'ancestry', label: 'Ancestry, FamilySearch & TreeVault', hub: '/ancestry-support', articles: ANCESTRY_ARTICLES },
];

export const ARTICLES = ARTICLE_CATEGORIES.flatMap((cat) =>
  cat.articles.map((article) => ({ ...article, category: cat.key, categoryLabel: cat.label }))
);

export const articlePath = (slug) => `/blog/${slug}`;

export function findArticle(slug) {
  return ARTICLES.find((article) => article.slug === slug);
}

export function articlesIn(categoryKey) {
  return ARTICLES.filter((article) => article.category === categoryKey);
}

export function relatedArticles(article, count = 4) {
  return articlesIn(article.category)
    .filter((other) => other.slug !== article.slug)
    .slice(0, count);
}

export const SUPPORT_SLUGS = [
  'ftm-2024-not-opening-fix',
  'fix-familysync-errors',
  'troubleshooting-family-tree-maker-2019',
  'fixing-broken-media-links-ftm-2019',
  'backup-and-restore-ftm-2024',
  'transfer-ftm-2019-to-new-computer',
  'treevault-cloud-services-guide',
  'avoid-ftm-2019-data-corruption',
];

export const SUPPORT_ARTICLES = SUPPORT_SLUGS.map(findArticle).filter(Boolean);

export const FEATURED_SLUGS = [
  'install-family-tree-maker-2024-windows',
  'fix-familysync-errors',
  'fixing-broken-media-links-ftm-2019',
  'upgrade-to-family-tree-maker-2024',
  'treevault-cloud-services-guide',
  'transfer-ftm-2019-to-new-computer',
];

export const FEATURED_ARTICLES = FEATURED_SLUGS.map(findArticle).filter(Boolean);
